import { map } from 'rxjs/operators';

import { BreakpointObserver } from '@angular/cdk/layout';
import { Injectable, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

@Injectable({
  providedIn: 'root',
})
export class ScreenSizeService {
  private readonly desktopBreakpoint = '(min-width: 960px)';
  private readonly tabletBreakpoint = '(min-width: 769px) and (max-width: 959px)';
  private readonly mobileBreakpoint = '(max-width: 768px)';
  private breakpointObserver = inject(BreakpointObserver);

  private isDesktop$;
  private isTablet$;
  private isMobile$;

  public readonly isDesktop;
  public readonly isTablet;
  public readonly isMobile;

  constructor() {
    this.isDesktop$ = this.breakpointObserver
      .observe([this.desktopBreakpoint])
      .pipe(map((result) => result.matches));

    this.isTablet$ = this.breakpointObserver
      .observe([this.tabletBreakpoint])
      .pipe(map((result) => result.matches));

    this.isMobile$ = this.breakpointObserver
      .observe([this.mobileBreakpoint])
      .pipe(map((result) => result.matches));

    this.isDesktop = toSignal(this.isDesktop$, { initialValue: false });
    this.isTablet = toSignal(this.isTablet$, { initialValue: false });
    this.isMobile = toSignal(this.isMobile$, { initialValue: true });
  }

  public readonly screenType = computed(() => {
    if (this.isDesktop()) return 'desktop';
    if (this.isTablet()) return 'tablet';
    return 'mobile';
  });

  isCurrentlyDesktop(): boolean {
    return this.isDesktop();
  }

  isCurrentlyTablet(): boolean {
    return this.isTablet();
  }

  isCurrentlyMobile(): boolean {
    return this.isMobile();
  }
}
